export default __webpack_public_path__ + "static/media/grain_of_aerosiderite.2bb98ef2.png";